import { Store } from '@ngxs/store';
import { filter, map, MonoTypeOperatorFunction, of, switchMap } from 'rxjs';
import { GotoNewTerms, ShowUpdatedTermsNotification } from './updated-terms.actions';
import { UpdatedTermsState } from './updated-terms.state';

export const filterForUpdatedTerms: (store: Store, gotoNewTermsPage: boolean) => MonoTypeOperatorFunction<unknown> =
  (store: Store, gotoNewTermsPage: boolean) => obs$ =>
    obs$.pipe(
      switchMap(() => store.selectOnce(UpdatedTermsState.arePlatformTermsUpdated)),
      switchMap(termsUpdated =>
        termsUpdated ? store.dispatch(gotoNewTermsPage ? new GotoNewTerms() : new ShowUpdatedTermsNotification()).pipe(map(() => true)) : of(false)
      ),
      filter(termsUpdated => !termsUpdated)
    );
